import { Stack, Box, Paper, Button, CircularProgress } from "@mui/material";
import TitlePage from "@components/atoms/TitlePage/TitlePage";
import TitlePaper from "@components/atoms/TitlePaper/TitlePaper";
import InputText from "@components/atoms/InputText/InputText";
import { ICreateProductUI } from "src/types/organisms";
import { useFormValidate } from "@utils/hooks";
import ErrorAlert from "@components/atoms/ErrorAlert/ErrorAlert";
const CreateProductUI = ({
  register,
  onSubmit,
  isLoading,
  showError,
  errors,
  closeError,
  handleCancelClick
}: ICreateProductUI) => {
  const {
    validateField
  } = useFormValidate();
  return <>
      <TitlePage title="Crear producto" subtitle="Desde este panel, puedes crear un producto y proporcionar su nombre, referencia y precio." />
      <Paper elevation={12} sx={{
      width: 1,
      padding: "24px",
      marginTop: 3
    }} onKeyDown={e => e.key.toLowerCase() === "enter" ? onSubmit() : null}>
        <TitlePaper title="Información del producto" subtitle="Llena los datos de tu nuevo producto aquí." />
        <Stack component="form" direction={"row"} justifyContent={"space-between"} alignItems={"flex-start"} marginTop={3} flexWrap={"wrap"} noValidate>
          <Box marginBottom={2} width={0.49}>
            <InputText label={"Nombre"} name={"description"} placeholder={"Ingresa el nombre"} register={register("description", {
            required: true
          })} helperText={validateField(errors?.description)} disabled={isLoading} />
          </Box>
          <Box marginBottom={2} width={0.49}>
            <InputText label={"Referencia"} name={"reference"} placeholder={"Ingresa la referencia"} register={register("reference", {
            required: true
          })} helperText={validateField(errors?.reference)} disabled={isLoading} />
          </Box>
          <Box marginBottom={2} width={0.49}>
            <InputText label={"Precio"} name={"price"} placeholder={"$ 0.00"} register={register("price", {
            required: true
          })} helperText={validateField(errors?.price)} disabled={isLoading} />
          </Box>
        </Stack>
      </Paper>
      <Stack direction={"row"} justifyContent={"flex-end"} marginTop={3} spacing={3}>
        <Button color="secondary" size="large" disabled={isLoading} onClick={handleCancelClick}>
          Cancelar
        </Button>
        <Button type="submit" size="large" onClick={isLoading ? () => null : onSubmit} endIcon={isLoading && <CircularProgress thickness={3} size={20} sx={{
        color: "white"
      }} />}>
          {isLoading ? "Creando producto" : "Crear producto"}
        </Button>
      </Stack>
      <ErrorAlert open={showError} onClose={closeError} message={"Lo sentimos, no se pudo crear este producto, intentalo nuevamente"} />
    </>;
};
export default CreateProductUI;